import { render, staticRenderFns } from "./OrganisationUser.vue?vue&type=template&id=09170010&scoped=true"
import script from "./OrganisationUser.vue?vue&type=script&lang=js"
export * from "./OrganisationUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09170010",
  null
  
)

export default component.exports